
import { Button, Modal, Input, Form, Select, message, Col, Row, DatePicker } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { requestError } from '../../controllers/functions';

const SchoolSubscriptionModal = ({ show, setOpenModal, record, refresh }) => {

  const [form] = Form.useForm();
  const [currencies, setCurrencies] = useState([]);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [state, setState] = useState({});

  useEffect(() => {

    setState({...record});
    form.resetFields();
    form.setFieldsValue({...record})
    axios.get( process.env.REACT_APP_API_URI+"/school/fees/currencies", {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then( done =>{
        setCurrencies(done.data);
      }).catch( error => {
          requestError({error});
      })

  }, [show, form, record ]);

  if(show !== isModalVisible){
    setIsModalVisible(show);
  }
  const extractTokenFromUrl = () =>{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get('token');
}
  const submit = (v) =>{
    axios.post(process.env.REACT_APP_API_URI+`/school/billing/${record?.id}`, v , {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then(res=>{
      message.success(res.data.res)
      setOpenModal(false);
      refresh();
    }).catch(error=>{
      requestError({error});
    }).finally(done=>{
        setLoading(false);
    })
  }

  const [loading, setLoading] = useState(false)

  const onChange = (event) => {
    setState({ ...state, [event.target.name] : event.target.value });
  }

  const { Option } = Select;

  return (
    <>
    
      <Modal 
      title={`SET SUBSCRIPTION FOR ${record?.name}`.toUpperCase() }
      open={isModalVisible} 
      onOk={()=>setOpenModal(false)} 
      onCancel={()=>setOpenModal(false)}
      footer={[
        <Button key="cancel" type=""  onClick={()=>{setOpenModal(false)}}>
            Cancel
        </Button>,
        <Button  key="submit" type="primary" htmlType="submit" form="currencyExchangeRateForm" loading={loading}>
          Submit
        </Button>     
      ]}
      >
      <Form
      layout="vertical"
      className="row-col"
      onFinish={(v)=> {
        submit(v);
      }}
      id="currencyExchangeRateForm" 
      form={form}
      >

        <Row>

          <Col xs={24} sm={24} md={8} lg={8} >
          <Form.Item
                style={{marginRight: 5}}
                name={'subscriptionType'}
                rules={[
                    { required: true, message: "Select Subscription!" },
                ]}
                >
                    <Select
                    showSearch
                    onChange={(value)=>setState({ ...state, subscriptionType : value })}
                    value={state?.subscriptionType}
                    placeholder="Select Subscription "
                    optionFilterProp="children"
                    filterOption={(input, option) => option.children.includes(input)}
                    >
                        {
                            [

                                {
                                    label : "Per Month",
                                    value : "monthly"
                                },
                                {
                                    label : "Per Term",
                                    value : "termly"
                                },
                                {
                                    label : "Per Year",
                                    value : "yearly"
                                }

                            ].map(item =>
                            <Option value={item.value} key={item.value}>{item.label}</Option>
                            )
                        }
                    </Select>
                </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={8} lg={8} >
            <Form.Item
                style={{marginRight: 5}}
                name={'subscriptionCurrencyId'}
                rules={[
                    { required: true, message: "Select Currency!" },
                ]}
                >
                    <Select
                    showSearch
                    onChange={(value)=>setState({ ...state, subscriptionCurrencyId : value })}
                    value={state?.subscriptionCurrencyId}
                    placeholder="Select Currency"
                    optionFilterProp="children"
                    filterOption={(input, option) => option.children.includes(input)}
                    >
                        {
                            currencies.map(item =>
                            <Option value={item.id} key={item.id}>{item.name}</Option>
                            )
                        }
                    </Select>
                </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={8} lg={8} >
            <Form.Item
            name = "subscriptionAmount" 
            style={{marginRight: 5}}
            rules={[
                { required: true, message: "Please enter Amount!" },
            ]}>
              <Input type='number' style={{ height : 32 }}  value={state?.level} onChange={onChange} name = "subscriptionAmount" placeholder="Amount" />
            </Form.Item>
          </Col>

        </Row>
        </Form>
      </Modal>
    </>
  );
};

export default SchoolSubscriptionModal;